import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA (offline support + caching)
serviceWorkerRegistration.register({
  onSuccess: () => console.log('[Class-Tech] App ready for offline use.'),
  onUpdate: () => {
    // Optionally notify user of new version
    console.log('[Class-Tech] New version available, refresh to update.');
  },
});
